const initialState = {
  accessToken: null,
  account: null,
};

export default function (state = initialState, action) {
  if (
    action.type === 'api/confirmAccount/response' ||
    action.type === 'api/createSession/response'
  ) {
    return {
      accessToken: action.payload.body.data.id,
      account: action.payload.body.included[0],
    };
  }
  if (action.type === 'LOGOUT') {
    return initialState;
  }

  return state;
}



// WEBPACK FOOTER //
// ./app/ducks/session.js